module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-12.111b9642.png";